<template>
  <div>
    <div class="content">
      <LoginLogo />

      <v-form ref="form" v-on:submit.prevent="submitForm">
        <v-container >
          <v-row>
            <div>
              Your free trial has ended.
              If you want to take a paid subscription please select a plan below.
              You can compare the different plans in our <a href="https://videobee.io/vb-pricing/" target="_blank">website</a>.
            </div>
          </v-row>

          <v-row>
            <v-tabs
              v-model="tab"
              bg-color="transparent"
              color="primary"
            >
              <v-tab v-bind:value="1"  style="width: 50%; text-transform: unset;">{{ $t('menus.getPaidSubscription.yearly') }}</v-tab>
              <v-tab v-bind:value="2" style="width: 50%; text-transform: unset;">{{ $t('menus.getPaidSubscription.monthly') }}</v-tab>
            </v-tabs>

            <v-tabs-window v-model="tab" class="bg-transparent">
              <v-tabs-window-item value="1">
                <div class="d-flex justify-space-between">
                  <v-card v-for="plan in getYearlyPlans" :key="plan.product.id" class="my-4 pb-10" width="30%">
                    <v-card-title class="justify-center">
                      {{ plan.product.name }}
                    </v-card-title>
                    <v-card-text>
                      <p>{{ plan.product.description }}</p>
                      <div class="text-center">
                        <tt>
                          € {{ ((getPrice(plan, "year").price) / 100).toFixed(2) }}
                          <br/>
                          {{ $t('menus.getPaidSubscription.perYear') }}
                        </tt>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-center" style="width: 100%; height: 40px; position: absolute; bottom: 0px;">
                      <v-btn
                        @click="selectPlan(plan, 'year')"
                        color="primary"
                        block
                        size="x-small">
                        {{ $t('menus.getPaidSubscription.selectPlan') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-tabs-window-item>
              <v-tabs-window-item value="2">
                <div class="d-flex justify-space-between">
                  <v-card v-for="plan in getMonthlyPlans" :key="plan.product.id" class="my-4 pb-10" width="30%">
                    <v-card-title class="justify-center">
                      {{ plan.product.name }}
                    </v-card-title>
                    <v-card-text>
                      <p>{{ plan.product.description }}</p>
                      <div class="text-center">
                        <tt>
                          € {{ ((getPrice(plan, "month").price) / 100).toFixed(2) }}
                          <br/>
                          {{ $t('menus.getPaidSubscription.perMonth') }}
                        </tt>
                      </div>
                    </v-card-text>
                    <v-card-actions class="justify-center" style="width: 100%; height: 40px; position: absolute; bottom: 0px;">
                      <v-btn
                        @click="selectPlan(plan, 'month')"
                        color="primary"
                        block
                        size="x-small">
                        {{ $t('menus.getPaidSubscription.selectPlan') }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-tabs-window-item>
            </v-tabs-window>
          </v-row>


          <v-row class="mt-5">
            <v-col cols="12" offset="0">
              <v-btn type="button" v-on:click="logout" class="bg-primary" block>Logout</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-form>

    </div>
  </div>
</template>


<script>
import { useAuthStore } from '@/stores/AuthStore.js'
import { useSystemStore } from '@/stores/SystemStore.js'
import LoginLogo from './components/LoginLogo.vue'

export default {
  name: "SelectSubscription",
  components: {
    LoginLogo,
  },
  data: function() {
    return {
      tab: null,
      errorMessage: '',
    };
  },
  mounted: function() {
    if (this.$canControlTenantConfig()) {
      this.refreshSubscription();
    }
  },
  methods: {
    logout: function() {
      this.$router.push('/account/logout');
    },
    submitForm: function() {
      console.log("submit form")
    },
    refreshSubscription: function() {
      if (!this.contextNodeId) {
        return;
      }

      const systemStore = useSystemStore();
      systemStore.refreshSubscription(this.contextNodeId);
    },
    selectPlan: function(plan, interval) {
      let self = this;
      this.errorMessage = "";

      const payload = {
        contextNodeId: this.contextNodeId,
        body: {}
      }

      const price = this.getPrice(plan, interval);

      payload.body[price.id] = 1;

      const systemStore = useSystemStore();
      systemStore.subscribeForPlan(payload)
      .then(function(response) {
        if (response && response.data && response.data.url) {
          window.location = response.data.url;
        }
      })
      .catch(function(error) {
        if (error &&
            error.response &&
            error.response.data &&
            error.response.data.error &&
            error.response.data.error.message) {
          self.errorMessage = self.$replaceT(error.response.data.error.message.code, error.response.data.error.message.params, error.response.data.error.message.content);
        } else {
          console.error(error);
          self.errorMessage = "Error!";
        }
      });
    },
    sortYearlyPlans: function(a, b) {
      return this.sortPlans(a, b, 'year');
    },
    sortMonthlyPlans: function(a, b) {
      return this.sortPlans(a, b, 'month');
    },
    sortPlans: function(a, b, interval) {
      let priceA = this.getPrice(a, interval).price;
      let priceB = this.getPrice(b, interval).price;
      if (priceA > priceB) return 1;
      if (priceA < priceB) return -1;
      return 0;
    }
  },
  computed: {
    dbUser: function() {
      const authStore = useAuthStore();
      return authStore.dbUser;
    },
    contextNodeId: function() {
      /*
      if (
          this.dbUser &&
          this.dbUser.groupnodes &&
          this.dbUser.groupnodes[0] &&
          this.dbUser.groupnodes[0].nodeid
      ) {
        return this.dbUser.groupnodes[0].nodeid;
      }
      */

      const authStore = useAuthStore();
      const rootNodeId = authStore.rootNodeId;

      return rootNodeId || null;
    },

    getSubscription: function() {
      const systemStore = useSystemStore();
      return systemStore.getSubscription;
    },

    getPlans: function() {
      if (this.getSubscription && this.getSubscription.plans) {
        return Object.values(this.getSubscription.plans);
      }
      return false;
    },
    getPrice: function() {
      return (plan, interval) => {
        if (!plan || !plan.prices) {
          return null;
        }
        return plan.prices.find(x => x.interval === interval);
      }
    },
    getMonthlyPlans: function() {
      if (this.getPlans) {
        let plans = this.getPlans.filter(plan => this.getPrice(plan, "month"));
        plans.sort(this.sortMonthlyPlans);
        return plans;
      }

      return [];
    },
    getYearlyPlans: function() {
      if (this.getPlans) {
        let plans = this.getPlans.filter(plan => this.getPrice(plan, "year"));
        plans.sort(this.sortYearlyPlans);
        return plans;
      }

      return [];
    },
  }
}
</script>
